import { render, staticRenderFns } from "./TagItemEditor.vue?vue&type=template&id=1885daa7&scoped=true&"
import script from "./TagItemEditor.vue?vue&type=script&lang=js&"
export * from "./TagItemEditor.vue?vue&type=script&lang=js&"
import style0 from "./TagItemEditor.vue?vue&type=style&index=0&id=1885daa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1885daa7",
  null
  
)

export default component.exports